<template>
  <!-- Box -->
  <div class="heigzhj ">
    <el-row class="row-bg qeqe" style="height:auto">
      <lunbot/>
    </el-row>

    <!-- 最新任务 -->
    <div class="title_index">
      <div class="name">最新任务</div>
      <div class="detailed">
        <div>资金托管</div>
        <div style="margin-left: 28px;">交易保障</div>
      </div>
    </div>
    <Thelistofdata/>

    <!-- 无代码KeplerPAT技术优势 -->
    <keplerpat/>

    <!-- 赋能企业数字化转型 -->
    <div class="title_index">
      <div class="name">赋能企业数字化转型</div>
      <div class="detailed">
        <div>为企业数字化系统开发降本增效</div>
      </div>
    </div>
    <numberZx/>

    <!-- 接单流程  Order-->
    <OrderProcess/>

    <!-- 我们的保障 -->
    <div class="title_index">
      <div class="name">我们的保障</div>
      <div class="detailed">
        <div>多重保障</div>
        <div style="margin-left: 28px;">全方位服务</div>
      </div>
    </div>
    <Ourprotection/>
    <!-- 咨询建议 -->
    <advice/>
    <!-- //注册弹窗  登录框 -->
    <activity/>
  </div>
</template>

<script>
import lunbot from '@/components/Lunbot/lunbot'
import Thelistofdata from '@/components/Lunbot/Thelistofdata'
import keplerpat from '@/components/Lunbot/keplerpat' // 开普勒 视频
import numberZx from '@/components/Lunbot/numberZx' // 赋能企业数字化转型
import OrderProcess from '@/components/Lunbot/OrderProcess' // 接单流程
import Ourprotection from '@/components/Lunbot/Ourprotection'
import activity from '@/components/xmgc/activity'
import advice from '@/components/xmgc/ZXJY'
export default {
  name: "index",
  data() {
    return {
      bannerHeight: document.documentElement.clientHeight,
    }
  },
  mounted() {
    console.log(this.bannerHeight, "we")
  },
  methods: {
    // 快速定位
    nextT(i) {
      // alert(i);
      if (i == "xt") {
        document.getElementById("xmglid").scrollIntoView({ behavior: 'smooth' });
      } else if (i == "APP") {
        document.getElementById("appid").scrollIntoView({ behavior: 'smooth' });
      }
    },

  },
  components: {
    Ourprotection: Ourprotection,
    Thelistofdata: Thelistofdata,
    keplerpat: keplerpat,
    numberZx: numberZx,
    OrderProcess: OrderProcess,
    lunbot: lunbot,
    advice: advice,
    activity: activity
  }
}
</script>

<style scoped>
/* 当前页面的最外部div 12-02 */
/* .Box{
    filter:progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
    -webkit-filter: grayscale(100%);
  } */
.gundinys {
  width: 30px;
  margin: 0 -16px;
  cursor: pointer;
  z-index: 20;
  position: absolute;
  bottom: 30px;
  color: #000000;
}


.heigzhj {
  min-height: 800px;
}

.row-bg {
  position: relative;
  /* border: 1px solid #000000; */
  width: 100%;
  height: 903px;
  /* padding-bottom: 10px; */
  /* background-color:#F5F7FA; */
}

.bgimg {
  background: url(../assets/images/bannertu/001bj.png) no-repeat;
  /* background-size: 100% 100%; */
  background-position: -24px 50px;
}


/* 标题公共样式 */
.title_index {
  margin: 100px 0 72px 0;
}

.title_index .name {
  font-size: 72px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
  line-height: 84px;
}

.title_index .detailed {
  font-size: 32px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/main/index.vue